import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CardRouter from '../cards/CardRouter';


const FeaturesDetailsDialog = ({ open, hit, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Details
        <IconButton
          onClick={onClose}
          sx={{ color: 'text.secondary' }}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <CardRouter hit={hit} />
      </DialogContent>
    </Dialog>
  );
};

export default FeaturesDetailsDialog;

